import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  DatePicker,
  Select,
  Upload,
  message,
  Spin,
  Skeleton,
  Table,
  Divider,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import ds from "../../../Services/DataServices";
import { IntlProvider } from "react-intl";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import { userLogOut } from "../../../appRedux/actions/Auth";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import { formatDigits } from "../../../appRedux/actions";
import DuplicatePriceBook from "./DuplicatePriceBook";

const GeneralPriceBook = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();
  const [form] = Form.useForm();

  const  priceBookId = window.location.href.includes("generalpricebook/") ? window.location.href.split("generalpricebook/")[1] : "";

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );

  const [isSpinningLoading, setSpinningLoading] = React.useState(false);
  const [getIsLoading, setIsLoading] = React.useState(true);
  const [getTableData, setTableData] = React.useState([]);
  const [getBookID, setBookID] = React.useState("");
  const [isLoadingTable, setIsLoadingTable] = React.useState(false);
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true,
    PriceBookID: 0,
  });
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
  });

  //for common data -> store currency
  React.useEffect(() => {
    let commonData = getReduxCommonSetting;
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.currencyData
    ) {
      let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData;
      setCurrData(currencyData);
    }
  }, [getReduxCommonSetting]);

  React.useEffect(() => {
    dispatch(setCommonConfigs("0"));
    let url = window.location.href.split("generalpricebook/");
    let id = url.length > 1 ? url[1] : false;
    if (id) {
      var body = getPagination;
      body.PriceBookID = id;
      setPagination(body);
      setBookID(id);
      getBookData(body);
    } else {
      setSpinningLoading(false);
      message.info("No Details Available, Kindly Try Again...");
    }
    // getAddBookData();
  }, []);

  async function getBookData(body) {
    // ;
    const getData = ds.getGeneralBookProd(body);
    await getData
      .then((res) => {
        //;
        if (res.status == 200) {
          setIsLoading(false);
          setIsLoadingTable(false);
          if (res.data.msgCode == "GENERAL_SUCCESS") {
            if (res.data.data && res.data.data.length > 0) {
              let prodMapped = res.data.data.map((pPrice) => {
                return {
                  //   key: getRandomInt(100000000),
                  prodPID: pPrice.productPriceID,
                  productname: pPrice.productName,
                  supplyprice: pPrice.supplyPrice,
                  markup: pPrice.markup,
                  discount: pPrice.discount,
                  retailprice: pPrice.price,
                  minunits: pPrice.minUnits,
                  maxunits: pPrice.maxUnits,
                  prodid: pPrice.productID,
                  createdon: pPrice.createdOn,
                };
              });
              let paginationobj = {
                CurrentPageNo: res.data.data[0].currentPageNo,
                PageSize: res.data.data[0].pageSize,
                total: res.data.data[0].totalRecords,
                showSizeChanger: true,
                PriceBookID: getBookID,
              };
              setPagination(paginationobj);
              setTableData(prodMapped);
            } else {
              message.info("No Products Available, Kindly Add Products");
            }
          } else {
            setIsLoading(false);
            setIsLoadingTable(false);
            message.error("Something Went Wrong...");
          }
        } else {
          setIsLoading(false);
          setIsLoadingTable(false);
          message.error("Something Went Wrong...");
        }
      })
      .catch((e) => {
        setIsLoading(false);
        setIsLoadingTable(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      });
  }

  const columns = [
    {
      title: <IntlMessages id="products.addpricebook.products" />,
      dataIndex: "productname",
      key: "productname",
      render: (text, record) => {
        return (
          <span
            onClick={() =>
              history.push(
                `/dashboard/products/pricebook/productdetail/${record.prodid}`
              )
            }
            className="gx-link"
            style={{ fontWeight: "500" }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="products.addpricebook.retailprice" />,
      dataIndex: "retailprice",
      key: "retailprice",
      render: (text) => {
        return (
          <span style={{ fontWeight: "500" }}>{`${
            getCurrData.currencyCode
          } ${formatDigits(text, 2)}`}</span>
        );
      },
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoadingTable(true);
    var body = getPagination;
    body.CurrentPageNo = pagination.current;
    body.PageSize = pagination.pageSize;
    body.PriceBookID = getBookID;
    getBookData(body);
  };

  return (
    <Spin
      tip={<IntlMessages id="products.addeditpriceprod.savebook" />}
      spinning={isSpinningLoading}
      size="large"
    >
      <div className="Content-wrapper GeneralPriceBook-pg">
        <div className="align-items-center bread-crum">
          <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
            <a
              onClick={() => history.push("/Dashboard/products/main")}
              className="custm-glinkprimaryclr"
            >
              {<IntlMessages id="products.addpricebook.products" />}
            </a>
          </h3>
          <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
            <a
              onClick={() => history.push("/Dashboard/products/pricebook")}
              className="custm-glinkprimaryclr"
            >
              {<IntlMessages id="products.addpricebook.pricebook" />}
            </a>
          </h3>
          <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3 dk-dark-black">
            <a>
              {<IntlMessages id="products.addpricebook.generalpricebook" />}
            </a>
          </h3>
        </div>

        <Card
          className="gx-card mt-3"
          title={
            <>
              <h3 className="mt-3 mb-0">
                <IntlMessages id="products.addpricebook.generalpricebook" />{" "}
              </h3>
             <DuplicatePriceBook PriceBookID={priceBookId} /> 
            </>
          }
        >
          <Row>
            <Col md={24}>
              <p>
                <IntlMessages id="products.addpricebook.genbookdetail" />
              </p>
            </Col>
          </Row>
          <Divider />

          <Row className="mt-4">
            <Col lg={6} md={6} sm={12} xs={24}>
              <h3 className="mb-0">
                <IntlMessages id="products.addpricebook.customergroup" />
              </h3>
              <p className="mb-4">
                <IntlMessages id="products.addpricebook.allcustomers" />
              </p>
            </Col>

            <Col lg={6} md={6} sm={12} xs={24}>
              <h3 className="mb-0">
                <IntlMessages id="products.addpricebook.outlets" />
              </h3>
              <p className="mb-4">
                <IntlMessages id="products.addpricebook.alloutlets" />
              </p>
            </Col>

            <Col lg={6} md={6} sm={12} xs={24}>
              <h3 className="mb-0">
                <IntlMessages id="products.addpricebook.validfrom" />
              </h3>
              <p className="mb-4">
                <IntlMessages id="products.addpricebook.always" />
              </p>
            </Col>

            <Col lg={6} md={6} sm={12} xs={24}>
              <h3 className="mb-0">
                <IntlMessages id="products.addpricebook.validto" />{" "}
              </h3>
              <p className="mb-0">
                <IntlMessages id="products.addpricebook.always" />
              </p>
            </Col>
          </Row>
        </Card>

        {getIsLoading ? (
          <>
            <Skeleton count={5} height={30} />
          </>
        ) : (
          <>
            <Table
              className="gx-table-responsive"
              columns={columns}
              dataSource={getTableData}
              loading={isLoadingTable}
              pagination={getPagination}
              onChange={handleTableChange}
              // rowKey={(record) => record.key}
            />
          </>
        )}
      </div>
    </Spin>
  );
};

export default GeneralPriceBook;
